export default __webpack_public_path__ + "static/media/battery-2.61349fb1.svg";